import {inject, injectable} from "inversify";
import SystemConfig, {CONFIG_PARAMS} from "../system/SystemConfig";
import InitResult from "../connect/result/InitResult";
import {getter, getVal} from "../helpers";
import {calcCoin, calcCoins} from "./walletOperations";
import events from "../events/EventsObservable";
import {EVENTS} from "../events/baseEvents";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import Wallet from "./Wallet";
import Settings from "../settings/Settings";
import AddResult from "../connect/result/AddResult";
import PlatformSettings from "../connect/result/PlatformSettings";

@injectable()
export default class InitWallet {

    private wallet: Wallet;
    private config: SystemConfig;
    private initResult: InitResult;
    private settings: Settings;
    private platformSettings: PlatformSettings;
    private gameset: any;
    
    constructor(
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
    ) {
        this.wallet = wallet;
        this.config = config;
        this.gameset = config.gameset;

        // events.subscribe(EVENTS.INIT_SUCCESS, (eventName, initResult) => this.onInitSuccess(initResult))
    }

    async init(initResult: InitResult, settings: Settings, platformSettings: PlatformSettings) {
        this.initResult = initResult;
        this.settings = settings;
        this.platformSettings = platformSettings;
        await this.wallet.initSettings(settings, platformSettings, this);
        await this.wallet.init(initResult, platformSettings, this);
    }

    async initReplay(replayResult: AddResult, settings: Settings) {
        // this.initResult = initResult;
        this.settings = settings;
        await this.wallet.initSettings(settings,undefined, this);
        await this.wallet.initReplay(replayResult, settings, this);
    }

    getWallet() {
        return this.wallet;
    }

    /**
     * Set allowed BET values. If not set from server, default is 10 to 100.
     *
     */
    getCreditBets() {
        if (this.config.get(CONFIG_PARAMS.ONLY_COINS) == 1) {
            return [20];
        }
        if (this.settings.getCreditBets()) {
            return this.settings.getCreditBets();
        } else {
            return [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
        }
    }


}